import Layout from "../../components/Layout";
import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { useLang } from "../../utils/LangContext";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../utils/apiUtils";
import QrScanner from "react-qr-scanner";
import localStorageHelper from "../../utils/localStorageHelper";

function PublicJoinTeam() {
  const { t } = useLang();
  const [alert, setAlert] = useState(null);
  const navigate = useNavigate();
  const [form, setForm] = useState({ team_code: "", email: "" });
  const [errors, setErrors] = useState({});
  const [isScanning, setIsScanning] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!form.team_code.trim())
      newErrors.team_code = t("Team Code is required");
    if (!form.email.trim()) {
      newErrors.email = t("Email is required");
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(form.email)
    ) {
      newErrors.email = t("Enter a valid email address");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const url = `/api/v1/game/join-team/?team_code=${form.team_code}&email=${form.email}`;
      try {
        const response = await fetchData(url);
        if (response.answerOK) {
          console.log("Join successful:", response);

          localStorageHelper.setItem("team", response);

          navigate("/mobile-requirements?redirect=/game&mode=start");
        } else {
          console.error(response.error);
          setAlert(response.error);
        }
      } catch (error) {
        console.error("Error joining the team: ", error);
        setAlert("Error joining the team: " + error);
      }
    }
  };

  const handleScan = (data) => {
    if (data) {
      setForm({ ...form, team_code: data.text || data }); // Fill the team_code input with scanned data
      setIsScanning(false); // Close the scanner
    }
  };

  const handleError = (error) => {
    console.error("QR Scanner Error:", error);
    console.error("Camera access denied. Please allow camera permissions.");
  };

  return (
    <Layout>
      <div className="text-center">
        <h1 className="fw-bold">{t("Join Team")}</h1>

        {alert && <Alert variant="danger">{alert}</Alert>}

        <form className="mt-4" onSubmit={onSubmitHandler}>
          {/* Team Code Field */}
          <div className="mb-3">
            <input
              type="text"
              name="team_code"
              className="form-control"
              placeholder={t("Team Code")}
              value={form.team_code}
              onChange={handleChange}
            />
            {errors.team_code && (
              <div className="text-danger">{errors.team_code}</div>
            )}
          </div>

          {/* Email Field */}
          <div className="mb-3">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder={t("Email")}
              value={form.email}
              onChange={handleChange}
            />
            {errors.email && <div className="text-danger">{errors.email}</div>}
          </div>

          <button type="submit" className="btn btn-primary w-100">
            {t("Join Team")}
          </button>
        </form>

        {/* Button to Open QR Scanner */}
        <button
          onClick={() => setIsScanning(true)}
          className="btn btn-secondary w-100 mt-3"
        >
          {t("Scan QR Code")}
        </button>

        {/* QR Code Scanner Modal */}
        {isScanning && (
          <div className="modal d-block" tabIndex="-1">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{t("Scan QR Code")}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsScanning(false)}
                  ></button>
                </div>
                <div style={{ width: "100%", height: "300px" }}>
                  <QrScanner
                    delay={300}
                    onScan={handleScan}
                    onError={handleError}
                    constraints={{ video: { facingMode: "environment" } }}
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default PublicJoinTeam;
